function getLinkedinSlug(coder) {
  const linkedinUrl = coder?.social?.linkedin;
  const slug = linkedinUrl?.split('linkedin.com/in/')[1]?.split('?')[0]?.split('/')?.[0];
  return slug ? decodeURIComponent(slug) : undefined;
}

export {
  getLinkedinSlug,
};
